import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      appIntegrations: 'integrations/getAppIntegrations',
    }),
    copilotIntegration() {
      return this.appIntegrations.find(({ id }) => id === 'copilot');
    },
    hasValidCopilotIntegration() {
      return !!this.copilotIntegration?.hooks?.length;
    },
    copilotFrameConfig() {
      if (!this.hasValidCopilotIntegration || !this.currentChat) {
        return [];
      }

      const { account_id, display_id } = this.currentChat;
      const url = new URL(this.copilotIntegration.hooks[0].settings.url);
      url.searchParams.set('account_id', account_id);
      url.searchParams.set('conversation_id', display_id);

      return [{ url: url.toString(), type: 'frame' }];
    },
  },
};
